import * as engine from './engine.js';
import * as clock from './core/totalClock.js';
import {boardHTML} from '../utils/finishedNotification.js';
export function createLocalMatch({owner='guest',boardSize=5,botDifficulty=3,clockPreset='30+0'},first='human',now=Date.now()) {
  const state=engine.createMatch(boardSize,botDifficulty,1,first);
  state.owner=owner.toLowerCase();state.clockSpec=clock.selectClock(clockPreset);state.startedAt=now;
  state.clock={human:{clockSpec:state.clockSpec,clockRemainingMs:state.clockSpec.initialMs,clockRunningSince:null},bot:{clockSpec:state.clockSpec,clockRemainingMs:state.clockSpec.initialMs,clockRunningSince:null}};
  clock.resume(state.clock[first],now);
  state.scores={human:{totalScore:0,details:[]},bot:{totalScore:0,details:[]}};
  return state;
}
export function finishLocal(state,reason,loser,now=Date.now()) {
  const next=JSON.parse(JSON.stringify(state));next.status=reason==='forfeit'?'forfeit':'finished';next.endReason=reason;next.lostActor=loser;next.endedAt=now;next.draft=null;
  clock.pause(next.clock.human,now);clock.pause(next.clock.bot,now);return next;
}
export function expireLocal(state,now=Date.now()) {
  if(state.status!=='playing'||!clock.expired(state.clock[state.actor],now))return state;
  return finishLocal(state,'timeout',state.actor,now);
}
export function clockTransition(previous,next,now=Date.now()) {
  if(next.status!=='playing'){next.endedAt=now;next.endReason=next.endReason||'score';clock.pause(next.clock.human,now);clock.pause(next.clock.bot,now);}
  else if(previous.actor!==next.actor){clock.pause(next.clock[previous.actor],now);clock.resume(next.clock[next.actor],now);}
  return next;
}
export function localClocks(state,now=Date.now()) {
  return {sampledAt:now,receivedAt:now,mine:{remainingMs:clock.remaining(state.clock.human,now),running:state.status==='playing'&&state.clock.human.clockRunningSince!=null},opponent:{remainingMs:clock.remaining(state.clock.bot,now),running:state.status==='playing'&&state.clock.bot.clockRunningSince!=null}};
}
export function localBoard(state) {
  const board=state.human.map(row=>[...row]);
  if(state.draft?.letter)board[state.draft.row][state.draft.col]=state.draft.letter;
  return board;
}
export function localResult(state,profile={}) {
  const mine=state.scores.human,opponent=state.scores.bot;
  const winner=state.lostActor ? state.lostActor==='human'?'Bilgisayar':state.owner : mine.totalScore>opponent.totalScore?state.owner:mine.totalScore<opponent.totalScore?'Bilgisayar':null;
  return {local:true,myUsername:state.owner,username:state.owner,gameId:state.id,opponentUsername:'Bilgisayar',playerDisplayName:profile.displayName||'Sen',opponentDisplayName:'Bilgisayar',playerImage:profile.profileImage,opponentImage:'/logo192.png',playerScore:mine.totalScore,opponentScore:opponent.totalScore,playerBoardHTML:boardHTML(state.human,mine.details),opponentBoardHTML:boardHTML(state.bot,opponent.details),playerDetails:mine.details,opponentDetails:opponent.details,winner,loser:winner===state.owner?'Bilgisayar':winner==='Bilgisayar'?state.owner:null,isDraw:!winner,endReason:state.endReason||'score',isForfeit:state.endReason==='forfeit',boardSize:state.size,clockSpec:state.clockSpec,turnCount:state.moves,startTime:state.startedAt,duration:(state.endedAt||Date.now())-state.startedAt,botDifficulty:state.difficulty};
}
export function localListRecord(state,profile={}) {
  const result=localResult(state,profile);
  return {local:true,gameType:'bot',botDifficulty:state.difficulty,gameId:state.id,boardSize:state.size,clockSpec:state.clockSpec,opponent:'Bilgisayar',opponentDisplayName:'Bilgisayar',opponentImage:'/logo192.png',isMyTurn:state.actor==='human',myScore:result.playerScore,opponentScore:result.opponentScore,clocks:localClocks(state),players:[state.owner,'Bilgisayar'],finalScores:{[state.owner]:result.playerScore,Bilgisayar:result.opponentScore},playerBoards:{[state.owner]:state.human,Bilgisayar:state.bot},playerDetails:{[state.owner]:result.playerDetails,Bilgisayar:result.opponentDetails},playerDisplayNames:{[state.owner]:result.playerDisplayName,bilgisayar:'Bilgisayar'},playerImages:{[state.owner]:profile.profileImage,bilgisayar:'/logo192.png'},winner:result.winner,loser:result.loser,isDraw:result.isDraw,endReason:result.endReason,startTime:state.startedAt,date:state.endedAt,duration:result.duration,totalTurns:state.moves};
}
export class LocalGameController {
  constructor({state,compute,persist,onSnapshot,onError,now=Date.now}) {
    Object.assign(this,{state,compute,persist,onSnapshot,onError,now});this.closed=false;this.jobs=Promise.resolve();
    this.socket={readyState:1,authenticated:true,bufferedAmount:0,send:raw=>{void this.enqueue(JSON.parse(raw));}};
  }
  enqueue(message) {
    this.jobs=this.jobs.catch(()=>{}).then(()=>this.apply(message)).catch(error=>{if(!this.closed)this.onError?.(error);});return this.jobs;
  }
  async commit(next,score=true) {
    if(this.closed)return;
    if(score)next.scores=(await this.compute('score',{state:next})).result;
    if(this.closed)return;
    await this.persist(next);if(this.closed)return;const previous=this.state;this.state=next;this.onSnapshot?.(next,previous);
  }
  async apply(message) {
    if(this.closed)return;
    const previous=this.state,now=this.now();
    if(previous.status!=='playing')return;
    if(message.type==='bot') {
      if(previous.actor!=='bot')return;
      const next=(await this.compute('bot',{state:previous})).state;
      if(this.closed)return;
      // If a phone closed during the pending computer turn, account for the
      // scheduled computer move before charging the absent human's clock.
      const completedAt=message.recovered?Math.min(this.now(),previous.clock.bot.clockRunningSince+(previous.incoming?800:400)):this.now();
      const expired=expireLocal(previous,completedAt);
      if(expired!==previous){await this.commit(expired);return;}
      clockTransition(previous,next,completedAt);next.received=null;
      await this.commit(expireLocal(next,this.now()));return;
    }
    const expired=expireLocal(previous,now);
    if(expired!==previous){await this.commit(expired);return;}
    if(message.type==='tick')return;
    if(message.type==='forfeit'){await this.commit(finishLocal(previous,'forfeit','human',now));return;}
    if(previous.actor!=='human')return;
    const {row,col,letter}=message;
    let next;
    if(message.type==='placeOpponentLetter') {
      next=engine.placeIncoming(previous,row,col);next.received={row,col,letter:previous.incoming};
    } else if(message.type==='relocateOpponentLetter') {
      const received=previous.received;
      if(!received||previous.phase!=='own'||received.row!==message.oldRow||received.col!==message.oldCol||previous.human[row]?.[col]!=='')throw Error('Gelen harf taşınamadı.');
      next=JSON.parse(JSON.stringify(previous));next.human[received.row][received.col]='';next.human[row][col]=received.letter;next.received={row,col,letter:received.letter};
      if(next.draft?.row===row&&next.draft?.col===col)next.draft=null;
    } else if(message.type==='updateOwnLetterPlacement') {
      if(previous.phase!=='own')return;
      if(letter==='')next={...previous,draft:null};
      else {
        if(!engine.LETTERS.includes(letter)||previous.human[row]?.[col]!=='')throw Error('Harf yerleşimi geçersiz.');
        next={...previous,draft:{row,col,letter}};
      }
      if(JSON.stringify(next.draft)===JSON.stringify(previous.draft))return;
      await this.commit(next,false);return;
    } else if(message.type==='placeOwnLetter') {
      if(!previous.draft)throw Error('Önce harfini yerleştir.');
      const draft=previous.draft;next=engine.confirmHuman(previous,draft.row,draft.col,draft.letter);next.received=null;
    } else if(message.type==='voluntaryPass') {next=engine.passIncoming(previous);next.received=null;}
    else return;
    clockTransition(previous,next,now);await this.commit(next);
  }
  dispose(){this.closed=true;this.socket.readyState=3;}
}
